import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import {
  getStatus,
  getCurrentRate,
  getCurrentVoiceIndex,
  isAltEnabled,
  isSimplifiedReadingEnabled,
} from "./selectors";
import TTSStatus from "./TTSStatus";
import { TTSHighlightMode } from "./types";

export const sendStatus = createViewerAction(ViewerMethod.TTS_SEND_STATUS);
export const getSettings = createViewerAction(ViewerMethod.TTS_GET_SETTINGS);
export const playFromTop = createViewerAction(ViewerMethod.TTS_PLAY_FROM_TOP);
export const playFromLocation = createViewerAction(
  ViewerMethod.TTS_PLAY_FROM_LOCATION
);
export const playFromCurrentSelection = createViewerAction(
  ViewerMethod.TTS_PLAY_FROM_CURRENT_SELECTION
);
export const enableAltText = createViewerAction(
  ViewerMethod.TTS_ENABLE_ALT_TEXT
);
export const disableAltText = createViewerAction(
  ViewerMethod.TTS_DISABLE_ALT_TEXT
);
export const enableSimplifiedReading = createViewerAction(
  ViewerMethod.TTS_ENABLE_SIMPLIFIED_READING
);
export const disableSimplifiedReading = createViewerAction(
  ViewerMethod.TTS_DISABLE_SIMPLIFIED_READING
);
export const stop = createViewerAction(ViewerMethod.TTS_STOP);
export const pause = createViewerAction(ViewerMethod.TTS_PAUSE);
export const resume = createViewerAction(ViewerMethod.TTS_RESUME);
export const setVoiceIndex = createViewerAction(
  ViewerMethod.TTS_SET_VOICE_INDEX
);
export const setRawRate = createViewerAction(ViewerMethod.TTS_SET_RAW_RATE);
export const skipForward = createViewerAction(ViewerMethod.TTS_SKIP_FORWARD);
export const skipBack = createViewerAction(ViewerMethod.TTS_SKIP_BACK);
export const fetchVoices = createViewerAction(ViewerMethod.TTS_GET_VOICES);
export const setNoContentMsg = createViewerAction(
  ViewerMethod.TTS_SET_NO_CONTENT_MSG
);
export const setHighlightMode = createViewerAction(
  ViewerMethod.TTS_SET_HIGHLIGHT_MODE
);

// show where playback will start before is has started
export const cuePlayback = createViewerAction(ViewerMethod.TTS_CUE_PLAYBACK);
// remove visual playback cue
export const uncuePlayback = createViewerAction(
  ViewerMethod.TTS_UNCUE_PLAYBACK
);

// move tts highlighting back into view
export const recenter = createViewerAction(ViewerMethod.TTS_RECENTER);
// reposition tts playback to start from top of viewport
export const playFromViewport = createViewerAction(
  ViewerMethod.TTS_PLAY_FROM_VIEWPORT
);

// normally an audio cue highlight displays on tts open
// if a play is immediately following an open we don't want to show the cue
export const playPending = createViewerAction(ViewerMethod.TTS_PLAY_PENDING);

/**
 * Play from top or resume, depending on status
 */
export function play() {
  return function (dispatch, getState) {
    if (getStatus(getState()) === TTSStatus.PAUSED) {
      dispatch(resume());
    } else {
      dispatch(playFromTop());
    }
  };
}

export const applyTTSSettings = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setHighlightMode(TTSHighlightMode.WORD));
    dispatch(setRawRate(getCurrentRate(state)));

    dispatch(setVoiceIndex(getCurrentVoiceIndex(state)));
    if (isAltEnabled(state)) {
      dispatch(enableAltText());
    } else {
      dispatch(disableAltText());
    }

    if (isSimplifiedReadingEnabled(state)) {
      dispatch(enableSimplifiedReading());
    } else {
      dispatch(disableSimplifiedReading());
    }

    dispatch(getSettings());
  };
};
